import { atom } from "recoil";

export const currentUser = atom({
    key: "current-user",
    default: null
})

export const logIn = atom({
    key: "phone-auth",
    default: {}
})

export const currentCart = atom({
    key: "current-cart", 
    default: []
})

export const productAtom = atom({
    key: "product-item",
    default: {
        description: "",
        price: "",
        image: "",
        sources: [],
        quantity: 1,
        images: []
    }
})